import React, { Component } from 'react';
import './Chat.css'

import { Bubble, Send } from './Icons'
import { intlShape, FormattedMessage, defineMessages } from 'react-intl';
import MetadataInquiry from './MetadataInquiry';
import SaveConversation from '../SaveConversation';

const eventLabels = defineMessages({
  'abort': {
    id: 'Shared.Chat.CallCancelled',
    defaultMessage: 'Anruf abgebrochen'
  },
  'calling': {
    id: 'Shared.Chat.CallStarted',
    defaultMessage: 'Anruf gestartet'
  },
  'callend': {
    id: 'Shared.Chat.CallEnded',
    defaultMessage: 'Anruf beendet'
  },
  'accepted': {
    id: 'Shared.Chat.CallAccepted',
    defaultMessage: 'Anruf angenommen'
  },
  'denied': {
    id: 'Shared.Chat.CallDenied',
    defaultMessage: 'Anruf abgelehnt'
  },
  'online': {
    id: 'Shared.Chat.Online',
    defaultMessage: 'Online'
  },
  'offline': {
    id: 'Shared.Chat.Offline',
    defaultMessage: 'Offline'
  }
});

const otherMessages = defineMessages({
  'placeHolderWriteMessage': {
    id: 'Shared.Chat.SendMessage',
    defaultMessage: 'Schreiben Sie eine Nachricht'
  },
  'you': {
    id: 'Shared.Chat.You',
    defaultMessage: 'Sie'
  }
});

class Chat extends Component {
  static contextTypes = {
    intl: intlShape.isRequired,
  }

  state = {
    composeMessage: ''
  }

  constructor(props) {
    super(props);
    
    this.messageBottom = React.createRef();
  }

  onSubmitMessage(e) {
    e.preventDefault();

    if (!this.state.composeMessage.length) {
      return;
    }
    this.props.onMessage(this.state.composeMessage);
    this.setState({composeMessage: ''});

    this.refs.text.focus();
  }

  componentDidUpdate() {
    this.messageBottom.scrollIntoView({ behavior: "smooth" });
  }

  render() {
    const messageCopy = this.props.messages.slice();
    const unreadMessages = messageCopy.filter(m => !m.read);

    if (unreadMessages.length) {
      unreadMessages.forEach(m => m.read = true);
      if (this.props.onMessagesUpdate) {
        this.props.onMessagesUpdate(messageCopy);
      }
    }

    const log = this.props.events.filter(e => e.type in eventLabels).concat(this.props.messages).concat(this.props.metadataInquiries).sort((a, b)=> a.time.getTime() - b.time.getTime());

    const logElements = log.map((m,i) => {
      const isMessage = "text" in m;

      if (!isMessage && m.type === 'inquiry') {
        return <div
          key={i}
          className="message"
          style={{margin:'1em auto', textAlign: 'center'}}
        >
          <MetadataInquiry
            metadataId={m.metadataId}
            metadata={m.metadata}
            values={m.values}
            onChange={this.props.onMetadataChange}
          />
        </div>;
      }
      else if (!isMessage && m.type === 'saveconversation') {
        return <div
          key={'saveconversation'}
          className="message"
          style={{margin:'1em auto', textAlign: 'center'}}
        >
          <SaveConversation
            {...m}
            user={this.props.local}
            intl={this.context.intl}
            sendMail={(o) => this.props.sendMail(o)}
          />
        </div>;
      }
      else {
        const isLocal = (m.from === this.props.local.id) || m.from.id === this.props.local.id;
        const author = isLocal ? this.context.intl.formatMessage(otherMessages.you) : (this.props.remotes.find(r => r.id === m.from) || {}).name;  
        const text = isMessage ? m.text : (this.context.intl.formatMessage(eventLabels[m.type]) + ', ' + m.time.toLocaleTimeString('de-DE'));

        const showAuthor = (i === 0 || log[i - 1].from !== m.from);
        return <div
        key={i}
        className={"message " + (isMessage ? '' : 'event ') + (isLocal ? 'local' : 'remote') + (showAuthor ? ' showAuthor' : '')}>
          <div>
            <Bubble className="bubble" />
            <div className="author">{author}</div>
            <div className="content">{text}</div>
          </div>
        </div>;
      };
    });

    return (
      <div className="chat" style={{display:'flex', flexDirection: 'column', height: '100%'}}>
        <div className="messages" ref="messages">
          {logElements}
          <div className="message-bottom" ref={(el) => { this.messageBottom = el; }}></div>
        </div>
        <div className="compose">
          <form action="" method="" onSubmit={e => this.onSubmitMessage(e)}>
            <input
              autoComplete="off"
              type="text"
              ref="text"
              onChange={() => {}}
              placeholder={this.context.intl.formatMessage(otherMessages.placeHolderWriteMessage)}
              id={this.props.local.id + '-composefield'}
              onInput={(e) => this.setState({'composeMessage': e.target.value})}
              value={this.state.composeMessage}
            />
            <button type="submit">
              <div>
                <Send />
                <span>
                  <FormattedMessage
                    id="Shared.Chat.Send"
                    defaultMessage="Senden"
                  />
                </span>
              </div>
            </button>
          </form>
        </div>
      </div>
    )
  }
};

export default Chat;